import { render, staticRenderFns } from "./PopUpGeneratedReoports.vue?vue&type=template&id=531086c7&"
import script from "./PopUpGeneratedReoports.vue?vue&type=script&lang=ts&"
export * from "./PopUpGeneratedReoports.vue?vue&type=script&lang=ts&"
import style0 from "./PopUpGeneratedReoports.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports